import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMapEditFlat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMapEditFlat"><Path d="M8 6H12V8H8V16H5.5C4.67157 16 4 16.6716 4 17.5C4 18.3284 4.67157 19 5.5 19H19V13H21V21H5.5C3.567 21 2 19.433 2 17.5V6.5C2 4.567 3.567 3 5.5 3H8V6Z" fill="currentColor"/><Path d="M16.793 5.45996C17.8278 4.42513 19.5052 4.42519 20.54 5.45996C21.5749 6.49482 21.5749 8.17217 20.54 9.20703L16.7471 13H13V9.25293L16.793 5.45996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMapEditFlat;
